<template>
  <div class="register-container">
    <div class="register-box">
      <h2>账号注册</h2>
      <div>
        <label>账号</label>
        <input v-model="form.username" placeholder="请设置账号"/>
      </div>
      <div>
        <label>密码</label>
        <input v-model="form.password" type="password" placeholder="请设置密码"/>
      </div>
      <div>
        <label>确认密码</label>
        <input v-model="form.rePassword" type="password" placeholder="再次输入密码"/>
      </div>
      <button @click="handleRegister">完成注册</button>
      <div class="tip">
        <span @click="$router.push('/login')">已有账号？去登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { registerApi } from '@/api/user'
export default {
  name: 'RegisterView',
  data() {
    return {
      form: {
        username: '',
        password: '',
        rePassword: ''
      }
    }
  },
  methods: {
    async handleRegister() {
      if(!this.form.username || !this.form.password){
        alert('账号密码不能为空')
        return
      }
      if(this.form.password !== this.form.rePassword){
        alert('两次输入密码不一致')
        return
      }
      try {
        await registerApi({
          username: this.form.username,
          password: this.form.password
        })
        alert('注册成功，请前往登录')
        //注册成功跳回登录页
        this.$router.push('/login')
      } catch (err) {
        console.error(err)
        alert('注册失败')
      }
    }
  }
}
</script>

<style scoped>
.register-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #e8f4f8 0%, #f0f7fb 100%);
  gap: 60px;
  padding: 0 40px;
}

.register-left {
  width: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register-left img {
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
}

.register-box {
  width: 400px;
  padding: 36px 32px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(70, 130, 180, 0.12);
}

.register-box h2 {
  text-align: center;
  margin-bottom: 32px;
  color: #2c3e50;
  font-weight: 600;
}

.register-box div {
  margin: 16px 0;
}

.register-box label {
  display: block;
  margin-bottom: 6px;
  color: #445668;
  font-size: 15px;
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 14px;
  border: 1px solid #d0dde8;
  border-radius: 8px;
  font-size: 15px;
  background-color: #fafcfe;
}

input:focus {
  outline: none;
  border-color: #5499c7;
}

button {
  width: 100%;
  margin: 10px 0;
  padding: 12px;
  background: #4088bc;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

button:hover {
  background-color: #3375a4;
}

.tip {
  text-align: center;
  margin-top: 14px;
  color: #4088bc;
  cursor: pointer;
}

/* 小屏幕自适应 */
@media (max-width: 900px) {
  .register-container {
    flex-direction: column;
  }
  .register-left {
    width: 300px;
  }
}
</style>